export default __webpack_public_path__ + "static/media/balls.0bf0bccc.png";